import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';

const Footer = () => {
  return (
    <Box
      sx={{
        bgcolor: '#2C3E50',
        color: 'white',
        py: 6,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontFamily: 'Cinzel, serif' }}>
              DavidssonBVT
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Expertis inom byggnadsvård och trädgårdsarbete
            </Typography>
            <IconButton 
              href="https://www.facebook.com/davidssonbvt.se" 
              target="_blank"
              rel="noopener noreferrer"
              sx={{ 
                color: 'white',
                '&:hover': { 
                  color: '#3498DB',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              <FacebookIcon />
            </IconButton>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontFamily: 'Montserrat, sans-serif' }}>
              Kontakt
            </Typography>
            <Typography variant="body2">
              Tel: 076-14 14 707
            </Typography>
            <Link 
              href="mailto:davidssonbvt@gmail.com"
              sx={{
                color: 'white',
                textDecoration: 'none',
                '&:hover': { color: '#3498DB' }
              }}
            >
              <Typography variant="body2">
                davidssonbvt@gmail.com
              </Typography>
            </Link>
            <Typography variant="body2">
              Adress: Hagavägen 8
            </Typography>
            <Typography variant="body2">
              611 73 Vrena
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontFamily: 'Montserrat, sans-serif' }}>
              Länkar
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/"
                sx={{
                  color: 'white',
                  textDecoration: 'none',
                  '&:hover': { color: '#3498DB' }
                }}
              >
                Hem
              </Link>
              <Link
                component={RouterLink}
                to="/tjanster"
                sx={{
                  color: 'white',
                  textDecoration: 'none',
                  '&:hover': { color: '#3498DB' }
                }}
              >
                Tjänster
              </Link>
              <Link
                component={RouterLink}
                to="/om-oss"
                sx={{
                  color: 'white',
                  textDecoration: 'none',
                  '&:hover': { color: '#3498DB' }
                }}
              >
                Om Oss
              </Link>
              {/* <Link
                component={RouterLink}
                to="/kontakt"
                sx={{
                  color: 'white',
                  textDecoration: 'none',
                  '&:hover': { color: '#3498DB' }
                }}
              >
                Kontakt
              </Link> */}
            </Box>
          </Grid>
        </Grid>
        
        <Typography
          variant="body2"
          align="center"
          sx={{
            mt: 4,
            pt: 2,
            borderTop: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        >
          © {new Date().getFullYear()} DavidssonBVT. Alla rättigheter förbehållna.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 